/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
export default class EcommNudge {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el;
        this.ecommNudgeID = document.querySelector('[data-ecomm-nudge-id]').dataset.ecommNudgeId;
        this.finance = parent.finance;
        this.personalDetails = {};
        this.modelBodyCode = HONDA.CarConfigurator.data?.model?.modelBodyCode;
        this.trackPageView();
        this.bind();
    }

    bind() {
        HONDA?.MyAccount2?.addEventListener('login', () => this.fetchPersonalDetails());
    }

    sendNudge(el) {
        if (el.classList.contains('save-config--nudge') && this.finance.result) {
            this.saveConfigNudge(el.href);
        } else if (el.classList.contains('order-checkout--nudge')) {
            this.orderCheckoutNudge(el.href);
        } else if (el.classList.contains('continue-dealer--nudge')) {
            this.continueDealerNudge(el.href);
        }
    }

    async fetchPersonalDetails() {
        this.personalDetails = await HONDA?.MyAccount2?.client?.getPersonalDetails();
    }

    trackPageView() {
        if (window._etmc && this.ecommNudgeID) {
            window._etmc.push(['setOrgId', this.ecommNudgeID]); /* 536003459 is the value for QA. For Prod it will be "536003361" */
            window._etmc.push(['trackPageView']);
        }
    }

    saveConfigNudge(path) {
        // const financeQuote = this.finance.result; /** disable for HEC-671 **/

        if (window._etmc && this.ecommNudgeID && this.personalDetails) {
            window._etmc.push([
                'setUserInfo',
                {
                    email: this.personalDetails?.email,
                    details: { HondaID: this.personalDetails?.customerId },
                },
            ]);

            window._etmc.push([
                'trackWishlist',
                {
                    items: ['Finance Quote'],
                    skus: ['FinanceQuote'],
                },
            ]);
        }
    }

    continueDealerNudge(path) {
        if (window._etmc && this.modelBodyCode) {
            window._etmc.push([
                'trackEvent',
                {
                    name: 'ContinueWithRetailer',
                    details: { model: this.modelBodyCode },
                },
            ]);
        }
    }

    orderCheckoutNudge(path) {
        if (window._etmc && this.modelBodyCode) {
            window._etmc.push([
                'trackEvent',
                {
                    name: 'CheckoutStarted',
                    details: { model: this.modelBodyCode },
                },
            ]);
        }
    }
}
